import React from "react";
// import { Link } from "react-router-dom"
import withStyles from "@material-ui/core/styles/withStyles";
// import Tooltip from "@material-ui/core/Tooltip";

// import FormatAlignLeft from "@material-ui/icons/FormatAlignLeft";
import RemoveRedEyeOutlined from "@material-ui/icons/RemoveRedEyeOutlined";

import GridContainer from "../../../components/Grid/GridContainer.jsx";
import GridItem from "../../../components/Grid/GridItem.jsx";
// import NavPills from "../../../components/NavPills/NavPills.jsx";
import Card from "../../../components/Card/Card.jsx";
import CardBody from "../../../components/Card/CardBody.jsx";
import Button from "../../../components/CustomButtons/Button.jsx";

import imgPonderosa from "../../../assets/img/360photos/la-ponderosa-360-preview.jpg";
import imgCascPeriquera from "../../../assets/img/360photos/cascada-la-periquera-360-preview.jpg";
import imgNaranjal from "../../../assets/img/360photos/el-naranjal-360-preview.jpg";
import imgVillaTCabana from "../../../assets/img/360photos/villa-terracota-cabana-360-preview.jpg";
import imgVillaTCasa from "../../../assets/img/360photos/villa-terracota-casa-360-preview.jpg";
import imgArcabuco from "../../../assets/img/360photos/arcabuco-360-preview.jpg";
import imgRogitama from "../../../assets/img/360photos/rogitama-360-preview.JPG";
import imgVRouse from "../../../assets/img/360photos/villa-rouse-360-preview.JPG";
import imgCasaAdobe from "../../../assets/img/360photos/casa-adobe-360-preview.JPG";
import imgPompasola from "../../../assets/img/360photos/pompasola-360-preview.jpg";

import sectionPillsStyle from "../../../assets/jss/material-kit-pro-react/views/blogPostsSections/sectionPillsStyle.jsx";

function SectionPills({ ...props }) {
    const { classes } = props;

    return (
        <div className={classes.section}>
            {/*<GridContainer justify="center">
                <GridItem xs={12} sm={12} md={8} className={classes.textCenter}>
                    <NavPills
                        alignCenter
                        tabs={[
                            {
                                tabButton: "All",
                                tabContent: ""
                            },
                            {
                                tabButton: "World",
                                tabContent: ""
                            },
                            {
                                tabButton: "Arts",
                                tabContent: ""
                            },
                            {
                                tabButton: "Tech",
                                tabContent: ""
                            },
                            {
                                tabButton: "Business",
                                tabContent: ""
                            }
                        ]}
                    />
                    <div className={classes.tabSpace} />
                </GridItem>
            </GridContainer>*/}
            <GridContainer>
                <GridItem xs={12} sm={4} md={4}>
                    <Card raised background style={{ backgroundImage: "url(" + imgPonderosa + ")" }}>
                        <CardBody background>
                            {/*<Link to="/vista-360/la-ponderosa-1">*/}
                            <a href="https://goo.gl/maps/zssiBwBXokJ2" target="_blank" rel="noopener noreferrer">
                                <h3 className={classes.cardTitle}>
                                    La Ponderosa
                                </h3>
                            </a>
                            <p className={classes.category}>
                                <strong>
                                    Esta cabaña con estilo del Oeste Americano te sorprendera con su belleza,
                                    en esta experiencia 360° podrás observar todos los detalles que la hacen
                                    única.
                                </strong>
                            </p>
                            {/*<Link to="/vista-360/la-ponderosa-1">*/}
                            <a href="https://goo.gl/maps/zssiBwBXokJ2" target="_blank" rel="noopener noreferrer">
                                <Button round color="white">
                                    <RemoveRedEyeOutlined className={classes.icons} /> Ver
                                </Button>
                            </a>
                        </CardBody>
                    </Card>
                </GridItem>
                <GridItem xs={12} sm={4} md={4}>
                    <Card raised background style={{ backgroundImage: "url(" + imgVillaTCabana + ")" }}>
                        <CardBody background>
                            {/*<Link to="/vista-360/villa-terracota-cabana-1">*/}
                            <a href="https://goo.gl/maps/fVhxqnyC5jv" target="_blank" rel="noopener noreferrer">
                                <h3 className={classes.cardTitle}>
                                    Villa Terracota (Cabaña)
                                </h3>
                            </a>
                            <p className={classes.category}>
                                <strong>
                                    El estilo rústico hace de la cabaña un lugar único, con el espacio ideal
                                    para compartir con la familia y amigos. Cercano al taller de barro
                                    de Don Guillermo Bautista.
                                </strong>
                            </p>
                            {/*<Link to="/vista-360/villa-terracota-cabana-1">*/}
                            <a href="https://goo.gl/maps/fVhxqnyC5jv" target="_blank" rel="noopener noreferrer">
                                <Button round color="white">
                                    <RemoveRedEyeOutlined className={classes.icons} /> Ver
                                </Button>
                            </a>
                        </CardBody>
                    </Card>
                </GridItem>
                <GridItem xs={12} sm={4} md={4}>
                    <Card raised background style={{ backgroundImage: "url(" + imgVillaTCasa + ")" }}>
                        <CardBody background>
                            {/*<Link to="/vista-360/villa-terracota-casa-1">*/}
                            <a href="https://goo.gl/maps/xH1Xe67HPJu" target="_blank" rel="noopener noreferrer">
                                <h3 className={classes.cardTitle}>
                                    Villa Terracota (Casa)
                                </h3>
                            </a>
                            <p className={classes.category}>
                                <strong>
                                    Construida en adobe, mantiene el estilo propio y artesanal de una construcción
                                    hecha en Ráquira. En sus cercanías se encuentra el Taller de Barro de
                                    Don Guillermo Bautista.
                                </strong>
                            </p>
                            {/*<Link to="/vista-360/villa-terracota-casa-1">*/}
                            <a href="https://goo.gl/maps/xH1Xe67HPJu" target="_blank" rel="noopener noreferrer">
                                <Button round color="white">
                                    <RemoveRedEyeOutlined className={classes.icons} /> Ver
                                </Button>
                            </a>
                        </CardBody>
                    </Card>
                </GridItem>
                <GridItem xs={12} sm={4} md={4}>
                    <Card raised background style={{ backgroundImage: "url(" + imgCasaAdobe+ ")" }}>
                        <CardBody background>
                            {/*<Link to="/vista-360/casa-adobe-1">*/}
                            <a href="https://goo.gl/maps/cWrJEiK3Dsw" target="_blank" rel="noopener noreferrer">
                                <h3 className={classes.cardTitle}>
                                    Casa Adobe
                                </h3>
                            </a>
                            <p className={classes.category}>
                                <strong>
                                    Acogedor lugar, en el cual los detalles se encuentran en cada rincón del
                                    Alojamiento, brindando una estadía que despierta la imaginación y la
                                    curiosidad del visitante.
                                </strong>
                            </p>
                            {/*<Link to="/vista-360/casa-adobe-1">*/}
                            <a href="https://goo.gl/maps/cWrJEiK3Dsw" target="_blank" rel="noopener noreferrer">
                                <Button round color="white">
                                    <RemoveRedEyeOutlined className={classes.icons} /> Ver
                                </Button>
                            </a>
                        </CardBody>
                    </Card>
                </GridItem>
                <GridItem xs={12} sm={4} md={4}>
                    <Card raised background style={{ backgroundImage: "url(" + imgNaranjal + ")" }}>
                        <CardBody background>
                            {/*<Link to="/vista-360/el-naranjal-1">*/}
                            <a href="https://goo.gl/maps/py5iCgnPzER2" target="_blank" rel="noopener noreferrer">
                                <h3 className={classes.cardTitle}>
                                    Finca El Naranjal
                                </h3>
                            </a>
                            <p className={classes.category}>
                                <strong>
                                    En este sitio encontrarás tranquilidad, rodeándote de extensos valles y
                                    montañas en el horizonte. En el Alojamiento se respira un apacible clima y
                                    un ambiente familiar.
                                </strong>
                            </p>
                            {/*<Link to="/vista-360/el-naranjal-1">*/}
                            <a href="https://goo.gl/maps/py5iCgnPzER2" target="_blank" rel="noopener noreferrer">
                                <Button round color="white">
                                    <RemoveRedEyeOutlined className={classes.icons} /> Ver
                                </Button>
                            </a>
                        </CardBody>
                    </Card>
                </GridItem>
                <GridItem xs={12} sm={4} md={4}>
                    <Card raised background style={{ backgroundImage: "url(" + imgVRouse+ ")" }}>
                        <CardBody background>
                            {/*<Link to="/vista-360/villa-rouse-1">*/}
                            <a href="https://goo.gl/maps/a9ZRncn3Gfu" target="_blank" rel="noopener noreferrer">
                                <h3 className={classes.cardTitle}>
                                    Villa Rouse
                                </h3>
                            </a>
                            <p className={classes.category}>
                                <strong>
                                    Rodeado de una espléndida vista a las montañas de Gachantivá, este
                                    Alojamiento ofrece al visitante una conexión con la naturaleza y
                                    el aire fresco.
                                </strong>
                            </p>
                            {/*<Link to="/vista-360/villa-rouse-1">*/}
                            <a href="https://goo.gl/maps/a9ZRncn3Gfu" target="_blank" rel="noopener noreferrer">
                                <Button round color="white">
                                    <RemoveRedEyeOutlined className={classes.icons} /> Ver
                                </Button>
                            </a>
                        </CardBody>
                    </Card>
                </GridItem>
                <GridItem xs={12} sm={4} md={4}>
                    <Card raised background style={{ backgroundImage: "url(" + imgRogitama+ ")" }}>
                        <CardBody background>
                            {/*<Link to="/vista-360/rogitama-1">*/}
                            <a href="https://goo.gl/maps/4nU9NZcXHDs" target="_blank" rel="noopener noreferrer">
                                <h3 className={classes.cardTitle}>
                                    Rogitama Biodiversidad
                                </h3>
                            </a>
                            <p className={classes.category}>
                                <strong>
                                    Ejemplo de conservación natural y armonía con la naturaleza.
                                    Ubicado en una Reserva Natural, los colibríes rondan el sitio, rodeado
                                    de abundante fauna y flora.
                                </strong>
                            </p>
                            {/*<Link to="/vista-360/rogitama-1">*/}
                            <a href="https://goo.gl/maps/4nU9NZcXHDs" target="_blank" rel="noopener noreferrer">
                                <Button round color="white">
                                    <RemoveRedEyeOutlined className={classes.icons} /> Ver
                                </Button>
                            </a>
                        </CardBody>
                    </Card>
                </GridItem>
                <GridItem xs={12} sm={4} md={4}>
                    <Card raised background style={{ backgroundImage: "url(" + imgPompasola+ ")" }}>
                        <CardBody background>
                            {/*<Link to="/vista-360/pompasola-1">*/}
                            <a href="https://goo.gl/maps/KN7MiPXmfPn" target="_blank" rel="noopener noreferrer">
                                <h3 className={classes.cardTitle}>
                                    Pompasola
                                </h3>
                            </a>
                            <p className={classes.category}>
                                <strong>
                                    Con el estílo típico de la vivienda rural boyacense, la construcción
                                    hecha en adobe transmite tranquilidad a quienes la visitan. Con vista al desierto
                                    de la Candelaria.
                                </strong>
                            </p>
                            {/*<Link to="/vista-360/pompasola-1">*/}
                            <a href="https://goo.gl/maps/KN7MiPXmfPn" target="_blank" rel="noopener noreferrer">
                                <Button round color="white">
                                    <RemoveRedEyeOutlined className={classes.icons} /> Ver
                                </Button>
                            </a>
                        </CardBody>
                    </Card>
                </GridItem>
                <GridItem xs={12} sm={4} md={4}>
                    <Card raised background style={{ backgroundImage: "url(" + imgCascPeriquera + ")" }}>
                        <CardBody background>
                            {/*<Link to="/vista-360/cascada-la-periquera-1">*/}
                            <a href="https://goo.gl/maps/6rWpNSpPtJD2" target="_blank" rel="noopener noreferrer">
                                <h3 className={classes.cardTitle}>
                                    Cascada de la Periquera
                                </h3>
                            </a>
                            <p className={classes.category}>
                                <strong>
                                    Situada cerca al municipio de Villa de Leyva. Con una caida de agua
                                    de aproximadamente 15 m, maravilla natural en la cual se pueden practicar
                                    actividades y deportes de aventura.
                                </strong>
                            </p>
                            {/*<Link to="/vista-360/cascada-la-periquera-1">*/}
                            <a href="https://goo.gl/maps/6rWpNSpPtJD2" target="_blank" rel="noopener noreferrer">
                                <Button round color="white">
                                    <RemoveRedEyeOutlined className={classes.icons} /> Ver
                                </Button>
                            </a>
                        </CardBody>
                    </Card>
                </GridItem>
                <GridItem xs={12} sm={4} md={4}>
                    <Card raised background style={{ backgroundImage: "url(" + imgArcabuco + ")" }}>
                        <CardBody background>
                            {/*<Link to="/vista-360/arcabuco-1">*/}
                            <a href="https://goo.gl/maps/e151TuYpuZx" target="_blank" rel="noopener noreferrer">
                                <h3 className={classes.cardTitle}>
                                    Municipio de Arcabuco
                                </h3>
                            </a>
                            <p className={classes.category}>
                                <strong>
                                    Un pequeño, pero bello municipio ubicado en la provincia de Ricaurte (Boyacá).
                                    Gente amable, y deliciosas almojabanas le dan
                                    la bienvenida al turista.
                                </strong>
                            </p>
                            <a href="https://goo.gl/maps/e151TuYpuZx" target="_blank" rel="noopener noreferrer">
                                <Button round color="white">
                                    <RemoveRedEyeOutlined className={classes.icons} /> Ver
                                </Button>
                            </a>
                        </CardBody>
                    </Card>
                </GridItem>
            </GridContainer>
        </div>
    );
}

export default withStyles(sectionPillsStyle)(SectionPills);



// WEBPACK FOOTER //
// ./src/views/360CatalogPage/Sections/SectionPills.jsx